import React from 'react';
//* Styles
import CollapseItemStyle from './style';
const CollapseItem = ({ title, description, disable, status }) => {
    return (React.createElement(CollapseItemStyle, null,
        React.createElement("div", { id: 'collapse-item', className: `${status == 'open' ? 'active' : ''}`, status: status || 'close', disable: disable === false ? 'false' : disable && 'true' },
            React.createElement("div", { id: 'collapse-title' }, title),
            React.createElement("div", { id: 'collapse-description' },
                React.createElement("div", { id: 'inner-wrapper-description' }, description)))));
};
export default CollapseItem;
//# sourceMappingURL=index.js.map